import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { publicApi } from "@/lib/api";

/**
 * Global banner shown across the app when the backend reports maintenance.
 * Polls /api/maintenance/status every 30s and shows a sticky banner at the
 * top of the viewport. Stays out of the way (collapsible) when off.
 */
export default function MaintenanceBanner() {
  const [state, setState] = useState({ enabled: false, message: "" });

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const { data } = await publicApi.get("/maintenance/status");
        if (!cancelled) setState(data);
      } catch {
        /* ignore — banner is best-effort */
      }
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!state.enabled) return null;

  return (
    <div
      className="sticky top-0 z-50 bg-[#FECACA] border-b-2 border-[#7F1D1D] px-4 py-2"
      data-testid="maintenance-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-[#7F1D1D] flex-shrink-0" strokeWidth={2.5} />
        <div className="text-sm font-bold text-[#7F1D1D]">
          <span className="uppercase tracking-wide">Tryb konserwacji aktywny</span>
          {state.message && <span className="ml-2 font-normal">— {state.message}</span>}
        </div>
      </div>
    </div>
  );
}
